import React from 'react';
export function ViewListIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6a3 3 0 013-3h2a3 3 0 013 3v2a3 3 0 01-3 3H5a3 3 0 01-3-3V6zm3-1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1V6a1 1 0 00-1-1H5zM2 16a3 3 0 013-3h2a3 3 0 013 3v2a3 3 0 01-3 3H5a3 3 0 01-3-3v-2zm3-1a1 1 0 00-1 1v2a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 00-1-1H5zM12 14a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1zM12 4a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1zM12 18a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM12 8a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1z"
  }));
}